// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__QYqIL","choiceBoxes":"toolbarselects_choiceBoxes__2sa00","simpleField":"toolbarselects_simpleField__3uFGS"};